import { CREATE_SUGGESTION } from './../constants';
import { handleActions } from "redux-actions"

export const suggestion = handleActions(
  { 
    [ CREATE_SUGGESTION ]: (state, action) => action.payload,
  }, []
)